import { Component } from '@angular/core';
import { ConversationUIModule } from '../../../../ui/src/conversation-ui.module';
import { INBOX_SERVICE_PROVIDERS } from '../../../../core/src/lib/conversation-core.module';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'inbox-conversation-overlay',
  template: '<router-outlet></router-outlet>',
  imports: [ConversationUIModule, RouterOutlet],
  providers: [INBOX_SERVICE_PROVIDERS],
})
export class InboxConversationOverlayComponent {}
